import React from 'react';
import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import TaskStatus from 'FielderUtils/status/taskStatus';
import TaskDetailActions from './TaskDetailActions';
import Loading from '~/FielderElements/Loading/Loading';
import { StyleFielderTitleTypography } from '~/FielderElements/FielderElements.styles';

const Label = ({ children, dense = false }) => (
  <Typography
    variant={dense ? 'caption' : 'body2'}
    sx={(theme) => ({
      color: theme.palette.text.secondary,
      mr: 0.5,
      whiteSpace: 'nowrap',
    })}
  >
    {children}
  </Typography>
);

const Value = ({ children, dense = false }) => (
  <Typography
    variant={dense ? 'caption' : 'body2'}
    sx={{ fontWeight: 600, whiteSpace: 'nowrap' }}
  >
    {children}
  </Typography>
);

const TaskDetailHeader = (
  {
    lan,
    tab,
    taskData,
    showMenuActions,
    statusTask,
    session,
    showTaskByEmail,
    showDisabledTasks,
    changeOpacity,
    executePopupAction,
    fielderMsg,
    onCloseModal,
    showLoadingDetail,
  }) => {
  const showIdCustom =
    tab !== 'info' && tab !== 'exe' && tab !== 'route';

  const isDense = tab === 'info';

  return (
    <Grid
      container
      alignItems="center"
      sx={{ width: '100%', py: 1, px: 0, gap: 1, }}
    >
      {/* Title */}
      {!showLoadingDetail && (<Grid size="auto">
        <StyleFielderTitleTypography variant="body2" sx={{ mt: 1, ml: 2 }}>
          {lan.taskDetail}
        </StyleFielderTitleTypography>
      </Grid>)}
      {/* Actions button */}
      {!showLoadingDetail && showMenuActions &&
        statusTask !== TaskStatus.REVIEW &&
        session?.user?.role !== 'Fielder Client User' && (
          <Grid size="auto">
            <TaskDetailActions
              executePopupAction={executePopupAction}
              lan={lan}
              changeOpacity={changeOpacity}
              showTaskByEmail={showTaskByEmail}
              showDisabledTasks={showDisabledTasks}
              session={session}
              taskData={taskData}
              fielderMsg={fielderMsg}
              onCloseModal={onCloseModal}
            />
          </Grid>
        )}
      {/* Inline loading */}
      {showLoadingDetail && (
        <Grid size="auto">
          <Stack direction="row" spacing={1} alignItems="center">
            <Loading inline size="40px" thickness={1} />
            <Typography variant="body2">{lan.loading}</Typography>
          </Stack>
        </Grid>
      )}
      {/* Right info block */}
      <Grid size sx={{ ml: 'auto' }}>
        {/* Row 1: ID Fielder (+ optionally ID Custom) */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-end"
          flexWrap="wrap"
          useFlexGap
          sx={{ rowGap: 0.5, columnGap: 1, minHeight: 28, mr: 6 }}
        >
          <Label dense={isDense}>{lan.idFielder}:</Label>
          <Value dense={isDense}>{taskData?.idFielder}</Value>
          {showIdCustom && (
            <>
              <Label>{lan.idCustom}:</Label>
              <Value>{taskData?.number}</Value>
            </>
          )}
        </Stack>
        {/* Row 2: Folio + Company/Client (hidden in "info" tab) */}
        {tab !== 'info' && (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            flexWrap="wrap"
            useFlexGap
            sx={{ rowGap: 0.5, columnGap: 1, minHeight: 28, mr: 6 }}
          >
            <Label>{lan.folio}:</Label>
            <Value>{taskData?.folio ? taskData.folio : lan.noFolio}</Value>
            {!taskData?.showClientFields ? (
              <>
                <Label>{lan.company}:</Label>
                <Value>{taskData?.company}</Value>
              </>
            ) : (
              <>
                <Label>{lan.client}:</Label>
                <Value>{taskData?.client?.name}</Value>
              </>
            )}
          </Stack>
        )}
      </Grid>
    </Grid>
  );
};

export default TaskDetailHeader;
